module.exports = __webpack_public_path__ + "images/file_icons_v2/icns-5e585740c34f782286274ad0b15f6bf4.svg";